import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormsModule, ValueChangeEvent } from '@angular/forms';
import { ApexAxisChartSeries, ApexChart, ApexOptions, NgApexchartsModule } from "ng-apexcharts";
import { DynamicModalFormService } from '@share';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzFormModule } from 'ng-zorro-antd/form';
import { CommonModule } from '@angular/common';
import { NzTableModule } from 'ng-zorro-antd/table';
import { G2MiniAreaClickItem, G2MiniAreaData, G2MiniAreaModule } from '@delon/chart/mini-area';
import { format } from 'date-fns';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { ItemService } from '../../item/item.service';
import { Router } from '@angular/router';
import { NzInputModule } from 'ng-zorro-antd/input';
import { debounceTime, distinctUntilChanged, forkJoin, Subject, takeUntil } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { NumberInfoModule } from '@delon/chart/number-info';
import { UserService } from '../../user/user.service';
import { G2PieClickItem, G2PieComponent, G2PieData, G2PieModule } from '@delon/chart/pie';
import { NzMessageService } from 'ng-zorro-antd/message';
import { G2BarModule } from '@delon/chart/bar';
import { G2MiniBarModule } from '@delon/chart/mini-bar';
import { G2CardModule } from '@delon/chart/card';
import { TrendModule } from '@delon/chart/trend';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { PostService } from '../../post/post.service';
import { CapitalLetterPipe } from 'src/app/share/pipes/capital-letter.pipe';
//import { NgxChartsModule } from '@swimlane/ngx-charts';
@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    NgApexchartsModule,
    NzCardModule,
    NzGridModule,
    NzSelectModule,
    NzFormModule,
    FormsModule,
    CommonModule,
    NzTableModule,
    NzDividerModule,
    G2MiniAreaModule,
    NzInputModule,
    NumberInfoModule,
    G2PieModule,
    G2BarModule,
    G2MiniBarModule,
    G2CardModule,
    TrendModule,
    NzIconModule,
    NzToolTipModule,
    //NgxChartsModule,
    CapitalLetterPipe


  ],
  providers: [DynamicModalFormService],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {

  name = 'Angular';

  chartwidth: number = 700;
  height: number = 300;
  fitContainer: boolean = false;

  view: any[] = [600, 400];
  // options for the chart
  showXAxis = true;
  showYAxis = true;
  gradient = true;
  showLegend = true;
  showXAxisLabel = true;
  xAxisLabel = 'Country';
  showYAxisLabel = true;
  yAxisLabel = 'Sales';
  timeline = true;
  doughnut = true;
  colorScheme = {
    domain: ['#9370DB', '#87CEFA', '#FA8072', '#FF7F50', '#90EE90', '#9370DB']
  };
  //pie
  showLabels = true;
  legendPosition: string = 'below';
  //@ViewChild('genderpie', { static: false }) readonly pie!: G2PieComponent;
  listOfData: any[] = [];
  genderData: any[] = [
  ];
  gendertotal: any = 0;
  topLikedPosts: any[] = [];
  topLikedProducts: any[] = [];


  public generateData(baseval: any, count: any, yrange: any) {
    var i = 0;
    var series = [];
    while (i < count) {
      var x = Math.floor(Math.random() * (750 - 1 + 1)) + 1;
      var y =
        Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
      var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;

      series.push([x, y, z]);
      baseval += 86400000;
      i++;
    }
    return series;
  }


  // ApexCharts pie chart configuration to replace g2-pie
  apexPieChartOptions: ApexOptions = {
    series: [], // Empty array - will be populated from backend
    chart: {
      type: 'pie',
      height: 300,
      width: '100%', // Make chart responsive to container width
      animations: {
        enabled: true,
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350
        }
      }
    },
    labels: [], // Empty array - will be populated from backend
    dataLabels: {
      enabled: true,
      formatter: function (val: any, opts: any) {
        const series = opts.w.config.series;
        const total = series.reduce((a: number, b: number) => a + b, 0);
        const percentage = ((opts.w.globals.series[opts.seriesIndex] / total) * 100).toFixed(1);
        const count = opts.w.globals.series[opts.seriesIndex];
        return `${percentage}%\n(${count})`;
      },
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
        colors: ['#fff']
      },
      background: {
        enabled: true,
        foreColor: '#000',
        borderRadius: 2,
        borderWidth: 1,
        borderColor: '#fff',
        opacity: 0.9,
        dropShadow: {
          enabled: false
        }
      }
    },
    responsive: [
      {
        breakpoint: 1200,
        options: {
          chart: {
            height: 280
          },
          legend: {
            position: 'bottom',
            offsetY: 0,
            height: 100
          }
        }
      },
      {
        breakpoint: 768,
        options: {
          chart: {
            height: 250
          },
          legend: {
            position: 'bottom',
            offsetY: 0,
            height: 80
          }
        }
      },
      {
        breakpoint: 480,
        options: {
          chart: {
            height: 220,
            width: '100%'
          },
          legend: {
            position: 'bottom',
            offsetY: 0,
            height: 60
          },
          plotOptions: {
            pie: {
              donut: {
                size: '50%'
              }
            }
          },
          dataLabels: {
            style: {
              fontSize: '10px'
            }
          }
        }
      },
      {
        breakpoint: 320,
        options: {
          chart: {
            height: 200,
            width: '100%'
          },
          legend: {
            position: 'bottom',
            offsetY: 0,
            height: 50
          },
          plotOptions: {
            pie: {
              donut: {
                size: '40%'
              }
            }
          },
          dataLabels: {
            style: {
              fontSize: '9px'
            }
          }
        }
      }
    ],
    legend: {
      position: 'bottom',  // 👈 Moves legend below chart
      horizontalAlign: 'center', // (optional) Centers the legend
      floating: false,
      // offsetY: 0,
      // height: 230,
      // fontSize: '14px',
      // itemMargin: {
      //   horizontal: 10,
      //   vertical: 5
      // },
      formatter: function (seriesName: string, opts: any) {
        const series = opts.w.config.series;
        const total = series.reduce((a: number, b: number) => a + b, 0);
        const percentage = ((opts.w.globals.series[opts.seriesIndex] / total) * 100).toFixed(1);
        const count = opts.w.globals.series[opts.seriesIndex];
        return `${seriesName}: ${percentage}% (${count})`;
      }
    },
    plotOptions: {
      pie: {
        donut: {
          size: '65%'
        },
        offsetY: 0
      }
    },
    tooltip: {
      enabled: true,
      theme: 'dark',
      style: {
        fontSize: '12px'
      },
      custom: function ({ series, seriesIndex, dataPointIndex, w }: any) {
        // For pie charts, seriesIndex is the slice index
        const count = series[seriesIndex];
        const total = series.reduce((a: number, b: number) => a + b, 0);
        const percentage = ((count / total) * 100).toFixed(1);
        const label = w.globals.labels[seriesIndex]; // Use seriesIndex instead of dataPointIndex

        return `<div class="custom-tooltip">
          <div style="padding: 8px;">
            <div style="font-weight: bold; margin-bottom: 4px;">${label}</div>
            <div style="margin-bottom: 2px;">Count: <strong>${count}</strong></div>
            <div>Percentage: <strong>${percentage}%</strong></div>
          </div>
        </div>`;
      }
    }
  };
  apexPieChartPostOptions: ApexOptions = {
    series: [], // Empty array - will be populated from backend
    chart: {
      type: 'pie',
      height: 300,
      width: '100%', // Make chart responsive to container width
      animations: {
        enabled: true,
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350
        }
      }
    },
    labels: [], // Empty array - will be populated from backend
    dataLabels: {
      enabled: true,
      formatter: function (val: any, opts: any) {
        const series = opts.w.config.series;
        const total = series.reduce((a: number, b: number) => a + b, 0);
        const percentage = ((opts.w.globals.series[opts.seriesIndex] / total) * 100).toFixed(1);
        const count = opts.w.globals.series[opts.seriesIndex];
        return `${percentage}%\n(${count})`;
      },
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
        colors: ['#fff']
      },
      background: {
        enabled: true,
        foreColor: '#000',
        borderRadius: 2,
        borderWidth: 1,
        borderColor: '#fff',
        opacity: 0.9,
        dropShadow: {
          enabled: false
        }
      }
    },
    responsive: [
      {
        breakpoint: 1200,
        options: {
          chart: {
            height: 280
          },
          legend: {
            position: 'bottom',
            offsetY: 0,
            height: 100
          }
        }
      },
      {
        breakpoint: 768,
        options: {
          chart: {
            height: 250
          },
          legend: {
            position: 'bottom',
            offsetY: 0,
            height: 80
          }
        }
      },
      {
        breakpoint: 480,
        options: {
          chart: {
            height: 220,
            width: '100%'
          },
          legend: {
            position: 'bottom',
            offsetY: 0,
            height: 60
          },
          plotOptions: {
            pie: {
              donut: {
                size: '50%'
              }
            }
          },
          dataLabels: {
            style: {
              fontSize: '10px'
            }
          }
        }
      },
      {
        breakpoint: 320,
        options: {
          chart: {
            height: 200,
            width: '100%'
          },
          legend: {
            position: 'bottom',
            offsetY: 0,
            height: 50
          },
          plotOptions: {
            pie: {
              donut: {
                size: '40%'
              }
            }
          },
          dataLabels: {
            style: {
              fontSize: '9px'
            }
          }
        }
      }
    ],
    legend: {
      position: 'bottom',  // 👈 Moves legend below chart
      horizontalAlign: 'center', // (optional) Centers the legend
      floating: false,
      // offsetY: 0,
      // height: 230,
      // fontSize: '14px',
      // itemMargin: {
      //   horizontal: 10,
      //   vertical: 5
      // },
      formatter: function (seriesName: string, opts: any) {
        const series = opts.w.config.series;
        const total = series.reduce((a: number, b: number) => a + b, 0);
        const percentage = ((opts.w.globals.series[opts.seriesIndex] / total) * 100).toFixed(1);
        const count = opts.w.globals.series[opts.seriesIndex];
        return `${seriesName}: ${percentage}% (${count})`;
      }
    },
    plotOptions: {
      pie: {
        donut: {
          size: '65%'
        },
        offsetY: 0
      }
    },
    tooltip: {
      enabled: true,
      theme: 'dark',
      style: {
        fontSize: '12px'
      },
      custom: function ({ series, seriesIndex, dataPointIndex, w }: any) {
        // For pie charts, seriesIndex is the slice index
        const count = series[seriesIndex];
        const total = series.reduce((a: number, b: number) => a + b, 0);
        const percentage = ((count / total) * 100).toFixed(1);
        const label = w.globals.labels[seriesIndex]; // Use seriesIndex instead of dataPointIndex

        return `<div class="custom-tooltip">
          <div style="padding: 8px;">
            <div style="font-weight: bold; margin-bottom: 4px;">${label}</div>
            <div style="margin-bottom: 2px;">Count: <strong>${count}</strong></div>
            <div>Percentage: <strong>${percentage}%</strong></div>
          </div>
        </div>`;
      }
    }
  };
  apexLineChartOptions: ApexOptions = {
    chart: {
      type: 'line',
      height: 300,
      width: '100%',
      toolbar: {
        show: false // Hides the entire menu
      },
      animations: {
        enabled: true,
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350
        }
      },

    },
    series: [
      { name: 'Sales', data: [10, 41, 35, 51, 49, 62, 69] },
      { name: 'Revenue', data: [23, 12, 54, 61, 32, 56, 81] }
    ],
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul']
    },
    legend: {
      position: 'bottom',
      horizontalAlign: 'center',
      floating: false,
      formatter: (seriesName: string, opts: any) => {
        const series = opts.w.config.series.map((s: any) => s.data);
        const seriesIndexData = series[opts.seriesIndex];
        const total = seriesIndexData.reduce((a: number, b: number) => a + b, 0);
        const lastValue = seriesIndexData[seriesIndexData.length - 1];
        const percentage = total
          ? ((lastValue / total) * 100).toFixed(1)
          : '0';
        return `${seriesName}: ${percentage}% (Last: ${lastValue})`;
      }
    },
    dataLabels: {
      enabled: true,
      formatter: (val: any) => val.toString(),
      style: {
        fontSize: '12px',
        fontWeight: 'bold'
      }
    },
    tooltip: {
      enabled: true,
      theme: 'dark',
      style: { fontSize: '12px' },
      custom: ({ series, seriesIndex, dataPointIndex, w }: any) => {
        const value = series[seriesIndex][dataPointIndex];
        const category = w.globals.categories[dataPointIndex];
        return `
        <div style="padding: 8px;">
          <div style="font-weight: bold; margin-bottom: 4px;">${w.globals.seriesNames[seriesIndex]}</div>
          <div>Month: <strong>${category}</strong></div>
          <div>Value: <strong>${value}</strong></div>
        </div>
      `;
      }
    },
    responsive: [
      {
        breakpoint: 1200,
        options: {
          chart: { height: 280 },
          legend: { position: 'bottom', offsetY: 0, height: 100 }
        }
      },
      {
        breakpoint: 768,
        options: {
          chart: { height: 250 },
          legend: { position: 'bottom', offsetY: 0, height: 80 }
        }
      },
      {
        breakpoint: 480,
        options: {
          chart: { height: 200, width: '100%' },
          legend: { position: 'bottom', offsetY: 0, height: 60 },
          dataLabels: { style: { fontSize: '10px' } }
        }
      },
      {
        breakpoint: 320,
        options: {
          chart: { height: 200, width: '100%' },
          legend: { position: 'bottom', offsetY: 0, height: 50 },
          dataLabels: { style: { fontSize: '9px' } }
        }
      }
    ]
  };


  apexBarChartOptions: ApexOptions = {
    chart: {
      type: 'bar',
      height: 300,
      width: '100%',
      toolbar: {
        show: false // Hides the entire menu
      },
      animations: {
        enabled: true,
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350
        }
      },

    },
    title: { text: 'Apexcharts Bar Chart right click' },
    series: [],
    // xaxis: {
    //   type: 'category',
    //   tickAmount: 1,
    //   labels: {
    //     formatter: val => val
    //   }
    // },
    yaxis: [
      {
        title: {
          text: "Title1"
        },
      }
    ],
    responsive: [
      {
        breakpoint: 1200,
        options: {
          chart: { height: 280 },
          legend: { position: 'bottom', offsetY: 0, height: 100 }
        }
      },
      {
        breakpoint: 768,
        options: {
          chart: { height: 250 },
          legend: { position: 'bottom', offsetY: 0, height: 80 }
        }
      },
      {
        breakpoint: 480,
        options: {
          chart: { height: 200, width: '100%' },
          legend: { position: 'bottom', offsetY: 0, height: 60 },
          dataLabels: { style: { fontSize: '10px' } }
        }
      },
      {
        breakpoint: 320,
        options: {
          chart: { height: 200, width: '100%' },
          legend: { position: 'bottom', offsetY: 0, height: 50 },
          dataLabels: { style: { fontSize: '9px' } }
        }
      }
    ]
  };

  userRegBarChartOptions: ApexOptions;
  userAgebarChartOptions: ApexOptions;
  bizRegBarChartOptions: ApexOptions;
  postSearchChartOptions: ApexOptions;


  searchMap = {
    item_name: '',
    last_price: '',
    group_name: '',
    maincategory_name: '',
    category_name: '',
    subcategory_name: '',
    period: 'week',
  };

  isLoading = false;
  _pageSize = 10;
  _pageIndex = 1;
  total = 0;
  tableHeight: string;
  width: string;
  tablewidth: string;
  private readonly destroy$ = new Subject<void>();
  private readonly searchInput$ = new Subject<void>();
  productTotal: number = 0;
  productStatusCounts: { status: string, count: number }[] = [];

  years = Array.from({ length: new Date().getFullYear() - 2024 + 1 }, (_, i) => 2024 + i);
  selectedYear: number = new Date().getFullYear(); // Default selected year

  periods = ['week', 'month', 'quarter'];
  userTotal: number = 0;
  isChartReady: boolean = false; // Flag to control when chart renders
  isUserLocationChartReady: boolean = false;
  isUserAgeChartReady: boolean = false;
  isUserRegistrationChartReady: boolean = false;
  isBusinessRegistrationChartReady: boolean = false;
  isPostSearchHistoryChartReady: boolean = false;
  postData: any;
  productData: any;
  options = [{ value: "monthly", label: "Monthly" }, { value: "weekly", label: "Weekly" }];
  selectedValue = "monthly";
  bizselectedValue = "monthly";
  bizoptions = [{ value: "monthly", label: "Monthly" }, { value: "weekly", label: "Weekly" }];
  postSearchSelectedValue = 'Biz Post';
  postSearchoptions = [{ value: "Biz Post", label: "Business Post" },{ value: "User Post", label: "User Post" }];
  postSearchTitle: string = 'Business Post Search History';

  @HostListener('window:resize')
  calculateHeight() {
    // Subtract heights of header, footer, padding, etc.
    const offset = 410; // adjust based on your layout
    this.tableHeight = `${window.innerHeight - offset}px`;
    const offsetWidth = 400;
    this.width = `${window.innerWidth - offsetWidth}px`;
    //this.tablewidth=`${window.innerWidth - (offsetWidth + 200)}px`;
    this.tablewidth = this.width;

  }
  onYearChange(selectedYear: any): void {
    this.selectedYear = selectedYear;
    this.loadData();
  }

  constructor(private readonly itemService: ItemService, private readonly router: Router, private userService: UserService, private msg: NzMessageService, private readonly postService: PostService, private readonly cdr: ChangeDetectorRef) {

  }
  ngOnInit(): void {

    forkJoin({
      userpost: this.postService.getUserPostStatus(),
      bizpost: this.postService.getBizPostStatus(),
      overview: this.postService.getOverViewPostStatus()
    }).subscribe({
      next: (res) => {
        this.postData = res;
        this.apexPieChartPostOptions.series = [this.postData.overview.data.bizPosts, this.postData.overview.data.userPosts];
        this.apexPieChartPostOptions.labels = ['Business Post', 'User Post'];
      },
      error: (err) => console.error(err),
      complete: () => { console.log('Completed'); this.cdr.detectChanges(); }
    });



    this.userService.getLocationChartData().subscribe((res: any) => {
      this.apexBarChartOptions.series[0] = { name: 'Total', data: res.data };
      this.isUserLocationChartReady = true;
      console.log(this.apexBarChartOptions.series);
    });
    this.userService.getAgeChartData().subscribe((res: any) => {
      this.userAgebarChartOptions = JSON.parse(JSON.stringify(this.apexBarChartOptions));
      this.userAgebarChartOptions.series[0] = { name: 'Total', data: res.data };
      this.isUserAgeChartReady = true;
      console.log(this.userAgebarChartOptions.series);
    });
    this.userService.getRegistrationChartData().subscribe((res: any) => {
      this.userRegBarChartOptions = JSON.parse(JSON.stringify(this.apexBarChartOptions));
      this.userRegBarChartOptions.series[0] = { name: 'Total', data: res.data.month };
      this.isUserRegistrationChartReady = true;
      console.log(this.userRegBarChartOptions.series);
    });
    this.userService.getBusinessRegistrationChartData().subscribe((res: any) => {
      this.bizRegBarChartOptions = JSON.parse(JSON.stringify(this.apexBarChartOptions));
      this.bizRegBarChartOptions.series[0] = { name: 'Total', data: res.data.month };
      this.isBusinessRegistrationChartReady = true;
      console.log(this.bizRegBarChartOptions.series);
    });

    const params = new HttpParams().set("type", "Biz Post");
    this.userService.getPostSearchHistoryChartData(params).subscribe((res: any) => {
      this.postSearchChartOptions = JSON.parse(JSON.stringify(this.apexBarChartOptions));
      this.postSearchChartOptions.series = [{name: "Total",data: res.data.map((item: any) => item.y)}];
      this.postSearchChartOptions.xaxis = {categories: res.data.map((item: any) => item.x)};
      this.isPostSearchHistoryChartReady = true;
    });
    this.userService.getGenderChartData().subscribe((res: any) => {
      this.userTotal = res.data.total;
      this.genderData = res.data.genders.map((x: any) => { return { x: x.gender, y: x.count, name: x.gender, value: x.count } }).sort((a: any, b: any) => b.value - a.value);//x:x.gender,y:x.count,
      this.gendertotal = `${this.genderData.reduce((pre, now) => now.y + pre, 0).toFixed(2)}`;

      // Update ApexCharts pie chart with backend data
      this.apexPieChartOptions.series = this.genderData.map((x: any) => x.y);
      this.apexPieChartOptions.labels = this.genderData.map((x: any) => x.x);
      this.isChartReady = true; // Set the flag to true when chart data is ready
    });

    this.setupSearchDebounce();
    this.loadData();
    this.loadMostLikedPosts();
    this.loadMostLikedProducts();
    this.ProductTotal();
  }

  loadMostLikedPosts(): void {
    const params = new HttpParams().set('pageSize', '100').set('page', '1');

    this.postService.getItems(params).subscribe({
      next: (res: any) => {
        const adminPosts = (res?.data || []).filter((post: any) =>
          post.status === 'published' &&
          post.createdType === 'admin'
        );

        this.topLikedPosts = adminPosts
          .sort((a: any, b: any) => (b.post_like_count || 0) - (a.post_like_count || 0))
          .slice(0, 5);

        console.log('Top liked admin posts:', this.topLikedPosts);
      },
      error: (err) => {
        console.error('Error loading posts:', err);
      }
    });
  }
  loadMostLikedProducts(): void {
    const params = new HttpParams().set('pageSize', '1000').set('page', '1');

    this.postService.getItems(params).subscribe({
      next: (res: any) => {
        const posts = (res?.data || []).filter(
          (post: any) =>
            post.status?.toLowerCase() === 'published' &&
            !!post.product_name?.trim()
        );

        const productMap = new Map<string, any>();
        posts.forEach((post: any) => {
          const name = post.product_name.trim();
          const likes = Number(post.post_like_count) || 0;

          if (!productMap.has(name)) {
            productMap.set(name, {
              product_name: name,
              total_likes: likes,
              image: post.image || null,
              content: post.content || '',
              published_date: post.published_date || null,
            });
          } else {
            const existing = productMap.get(name);
            existing.total_likes += likes;
          }
        });
        this.topLikedProducts = Array.from(productMap.values())
          .sort((a, b) => b.total_likes - a.total_likes)
          .slice(0, 5);
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Error loading most liked products:', err);
      },
    });
  }

  totalProducts: number = 0;

  ProductTotal(): void {
    const params = new HttpParams()
      .set('page', '1')
      .set('pageSize', '1000');

    this.postService.getItems(params).subscribe({
      next: (res: any) => {
        const names = (res?.data ?? [])
          .map((x: any) => x?.product_name)
          .filter((n: any) => !!n && typeof n === 'string' && n.trim().length > 0)
          .map((n: string) => n.trim());
        this.productTotal = new Set(names).size || (res?.totalCount ?? 0);

        // Build per-status counts only for posts that have a product_name
        const status = new Map<string, number>();
        (res?.data ?? [])
          .filter((x: any) => !!x?.product_name)
          .forEach((x: any) => {
            const key = (x.status ?? 'unknown').toString();
            status.set(key, (status.get(key) || 0) + 1);
          });

        this.productStatusCounts = Array.from(status.entries())
          .map(([status, count]) => ({ status, count }))
          .sort((a, b) => b.count - a.count);
          // Sum total as sum of all counts
        this.productTotal = this.productStatusCounts.reduce((sum, item) => sum + item.count, 0);
      },
      error: (err) => {
        console.error('Error loading product name count:', err);
      }
    });
  }


  onFilterChange(filter: string) {
    if (filter == "weekly") {
      this.userService.getRegistrationChartData().subscribe((res: any) => {
        console.log(res);
        this.userRegBarChartOptions = JSON.parse(JSON.stringify(this.apexBarChartOptions));
        this.userRegBarChartOptions.series[0] = { name: 'Total', data: res.data.week };
        this.isUserRegistrationChartReady = true;
        console.log(this.userRegBarChartOptions.series);
      });
    } else {
      this.userService.getRegistrationChartData().subscribe((res: any) => {
        this.userRegBarChartOptions = JSON.parse(JSON.stringify(this.apexBarChartOptions));
        this.userRegBarChartOptions.series[0] = { name: 'Total', data: res.data.month };
        this.isUserRegistrationChartReady = true;
        console.log(this.userRegBarChartOptions.series);
      });
    }
  }
  onBizFilterChange(filter: string) {
    if (filter == "weekly") {
      this.userService.getBusinessRegistrationChartData().subscribe((res: any) => {
        this.bizRegBarChartOptions = JSON.parse(JSON.stringify(this.apexBarChartOptions));
        this.bizRegBarChartOptions.series[0] = { name: 'Total', data: res.data.week };
        this.isBusinessRegistrationChartReady = true;
        console.log(this.bizRegBarChartOptions.series);
      });
    } else {
      this.userService.getBusinessRegistrationChartData().subscribe((res: any) => {
        this.bizRegBarChartOptions = JSON.parse(JSON.stringify(this.apexBarChartOptions));
        this.bizRegBarChartOptions.series[0] = { name: 'Total', data: res.data.month };
        this.isBusinessRegistrationChartReady = true;
        console.log(this.bizRegBarChartOptions.series);
      });
    }
  }
  onPostSearchHistoryFilterChange(filter: string) {
    this.selectedValue = filter;
    if (filter === 'Biz Post') {
      this.postSearchTitle = 'Business Post Search History';
    } else if (filter === 'User Post') {
      this.postSearchTitle = 'User Post Search History';
    }

    const params = new HttpParams().set('type', filter);

    this.userService.getPostSearchHistoryChartData(params)
      .subscribe((res: any) => {
        this.postSearchChartOptions = JSON.parse(JSON.stringify(this.apexBarChartOptions));
        this.postSearchChartOptions.series = [{
          name: 'Total',
          data: res.data.map((item: any) => item.y)
        }];
        this.postSearchChartOptions.xaxis = {
          categories: res.data.map((item: any) => item.x)
        };
        this.isPostSearchHistoryChartReady = true;
      });
  }

  onSelect(data: any): void {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data: any): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data: any): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  onPageIndexChange(pageIndex: number): void {
    this._pageIndex = pageIndex;
    this.loadData();
  }
  onPeriodChange() {
    this.loadData();
  }
  setupSearchDebounce() {
    this.searchInput$.pipe(
      debounceTime(500),
    ).subscribe(() => {
      this.loadData();
    });
  }

  // Called on every input event
  onSearchInput() {
    this._pageIndex = 1;
    this.searchInput$.next();
  }

  loadData() {
    this.isLoading = true;

    // Prepare filters for server
    const filters = {
      item_name: this.searchMap.item_name,
      last_price: this.searchMap.last_price,
      group_name: this.searchMap.group_name,
      maincategory_name: this.searchMap.maincategory_name,
      category_name: this.searchMap.category_name,
      subcategory_name: this.searchMap.subcategory_name,
      year: this.selectedYear,
      period: this.searchMap.period
    };

    let params = new HttpParams()
      .set('page', this._pageIndex)
      .set('pageSize', this._pageSize)
      .set('filterValue', JSON.stringify(filters));

    this.itemService.getChartData(params).subscribe({
      next: (x) => {
        this.listOfData = x.data;
        this.total = x.total;
        this.isLoading = false;
      },
      error: () => this.isLoading = false
    });

  }

  detail(id: string) {
    this.router.navigate(['/pricechange', id]);
  }

  getPostPreview(content: string | null | undefined): string {
    if (!content) return '';
    const plainText = content.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    return plainText.length > 20 ? `${plainText.slice(0, 20)}...` : plainText;
  }

  format(val: number): string {
    return `Total ${val}`;
  }

  handleClick(data: G2PieClickItem): void {
    this.msg.info(`${data.item.x} - ${data.item.y}`);
  }

  // Handle ApexCharts pie chart selection
  onPieChartSelection(event: any): void {
    console.log('Pie chart selection:', event);
    if (event && event.dataPointIndex !== undefined) {
      const label = this.apexPieChartOptions.labels[event.dataPointIndex];
      const value = this.apexPieChartOptions.series[event.dataPointIndex];
      this.msg.info(`${label} - ${value} users`);
    }
  }
}
